module.exports = __webpack_public_path__ + "img/picture_ksdgfz01.35953046.png";